import sagarika from "../../assets/Orators/sagarika.jpg";
import valentina from "../../assets/Orators/valentina.jpg";
import thelma from "../../assets/Orators/thelma.jpg";
import amy from "../../assets/Orators/amy.jpg";
import esraa from "../../assets/Orators/esraa.jpg";
import raajasiri from "../../assets/Orators/raajasiri.jpg";
import srividya from "../../assets/Orators/srividya.jpg";
import faiza from "../../assets/Orators/faiza.jpg";
import parveen from "../../assets/Orators/praveen.jpg";
import akbar from "../../assets/Orators/akbar.jpg";
import emmanuel from "../../assets/Orators/emmanuel.jpg";



// New banners
import sagarika_banner from "../../assets/Orator Banners/sagarika_banner.jpg";
import valentina_banner from "../../assets/Orator Banners/valentina_banner.jpg";
import thelma_banner from "../../assets/Orator Banners/thelma_banner.jpg";
import amy_banner from "../../assets/Orator Banners/amy_banner.jpg";
import esraa_banner from "../../assets/Orator Banners/esraa_banner.jpg";
import raajasiri_banner from "../../assets/Orator Banners/raajasiri_banner.jpg";
import srividya_banner from "../../assets/Orator Banners/srividya_banner.jpg";
import faiza_banner from "../../assets/Orator Banners/faiza_banner.jpg";

import parveen_banner from "../../assets/Orator Banners/praveen_banner.jpg";
import akbar_banner from "../../assets/Orator Banners/akbar_banner.jpg";
import emmanuel_banner from "../../assets/Orator Banners/emmanuel_banner.jpg";


export const orators = [
  {
    id: "thelma-liverpool",
    image: thelma,
    name: "Thelma Liverpool",
    from: "United States",
    about: "CEO, Thanni Holding Corp",
    link: "/world-public-health-summit-orators/thelma-liverpool",
  },
  {
    id: "amy-gutman",
    image: amy,
    name: "Dr. Amy Gutman",
    from: "United States",
    about: "CEO, ToughLoveMD",
    link: "/world-public-health-summit-orators/amy-gutman",
  },
  {
    id: "srividya-narayanan",
    image: srividya,
    name: "Srividya Narayanan",
    from: "United States",
    about: "Northeastern University",
    link: "/world-public-health-summit-orators/srividya-narayanan",
  },
  {
    id: "faiza-arshad",
    image: faiza,
    name: "Faiza Arshad",
    from: "United Kingdom",
    about: "Dentistry",
    link: "/world-public-health-summit-orators/faiza-arshad",
  },
  {
    id: "esraa-elsisy",
    image: esraa,
    name: "Dr. Esraa Mohamed Elsisy",
    from: "Saudi Arabia",
    about: "Clinical Nutritionist",
    link: "/world-public-health-summit-orators/esraa-elsisy",
  },
  {
    id: "valentina-kordi",
    image: valentina,
    name: "Valentina Kordi",
    from: "Greece",
    about: "VK - People Development Services",
    link: "/world-public-health-summit-orators/valentina-kordi",
  },
  {
    id: "raajasiri-iyengar",
    image: raajasiri,
    name: "Dr. Raajasiri Iyengar",
    from: "India",
    about: "GA Digital (ICMR)",
    link: "/world-public-health-summit-orators/raajasiri-iyengar",
  },
  {
    id: "sagarika-limaye",
    image: sagarika,
    name: "Sagarika Limaye",
    from: "Scotland",
    about: "University Tuiuti do Paraná",
    link: "/world-public-health-summit-orators/sagarika-limaye",
  },
  {
    id: "parveen-smith",
    image: parveen,
    name: "Parveen Smith",
    from: "United Kingdom",
    about: "Multi-Global Awardee & Motivational Speaker",
    link: "/world-public-health-summit-orators/parveen-smith",
  },
  {
    id: "akbar-rashid",
    image: akbar,
    name: "Muhammad Akbar Rashid",
    from: "Pakistan",
    about: "New Al-SHIFA Eye Care Center (NAEC)",
    link: "/world-public-health-summit-orators/akbar-rashid",
  },
  {
    id: "emmanuel-obeagu",
    image: emmanuel,
    name: "Prof. Emmanuel Obeagu",
    from: "Zimbabwe",
    about: "Africa University",
    link: "/world-public-health-summit-orators/emmanuel-obeagu",
  },
];



export const thelma_data = {
  id: "thelma-liverpool",
  image: thelma,
  from: "United States",
  name: "Thelma Liverpool",
  banner: thelma_banner,
  about:
    "Thelma Liverpool is CEO of Thanni Holding Corp, creating patented medical devices to ease care for bedridden patients. A Howard and Fisk University alumna, she worked as a chemist at DuPont and later spent nine years in South Africa with the Peace Corps and running a business. With 3 patents (1 granted, 2 pending), her innovations are poised for global commercialization. She was recently nominated to 'Who's Who in America' for her contributions to healthcare innovation.",
};

export const amy_data = {
  id: "amy-gutman",
  image: amy,
  from: "United States",
  name: "Dr. Amy Gutman, MD, FACEP",
  banner: amy_banner,
  about:
    "Dr. Amy Gutman is a board-certified Emergency Medicine physician and CEO of ToughLoveMD. With 30+ years in clinical and corporate healthcare, she's an award-winning leader and global speaker. Her accolades include the CXO Leadership Innovator Award (2025), Healthcare 2.0 Award (2025), and EMS Physician of the Year (2016, 2019). A champion of resilience and health equity, her upcoming book 'Powerhouse Living' reflects her mission to transform mental and physical well-being worldwide.",
};

export const srividya_data = {
  id: "srividya-narayanan",
  image: srividya,
  from: "United States",
  name: "Srividya Narayanan",
  banner: srividya_banner,
  about:
    "Srividya Narayanan is a dental clinician and regulatory affairs specialist at Northeastern University. She integrates patient-centered care with strategic compliance oversight in medical and dental device development. Her aim is to advance safe, effective innovations while improving patient outcomes and regulatory alignment.",
};

// United Kingdom
export const faiza_data = {
  image: faiza,
  from: "United Kingdom",
  name: "Faiza Arshad",
  banner: faiza_banner,
  about:
    "Faiza Arshad is a former dental nurse and NHS leader turned health-tech advocate. She empowers dental professionals through public engagement, coaching, and education. Faiza’s mission is to modernize oral health awareness via inclusive campaigns, digital tools, and global storytelling that promote prevention and patient empowerment.",
};

// Saudi Arabia
export const esraa_data = {
  image: esraa,
  from: "Saudi Arabia",
  name: "Dr. Esraa Mohamed Elsisy",
  banner: esraa_banner,
  about:
    "Dr. Esraa Elsisy is Director of Clinical Nutrition at Naya Medical Tower, KSA, and founder of Lifestyle for You Clinics in Egypt. With over 8 years in therapeutic nutrition, she earned a master’s in cancer nutrition and is a doctoral researcher. She has worked internationally, founded a skincare brand, and is respected in Arab and European health communities for her innovation and passion in nutritional science.",
};

// Greece
export const valentina_data = {
  image: valentina,
  from: "Greece",
  name: "Valentina Kordi",
  banner: valentina_banner,
  about:
    "Valentina Kordi is a leading Mindset & High-Performance Consultant for Executives, Teams, and Entrepreneurs. She is an international motivational speaker, TEDx speaker and author of “Success is a Mind Game” and “The Mirror Effect.” For 15+ years, she has led VK - People Development Services, consulting global corporations like Microsoft, Pfizer, Unilever, and more. With degrees from Newport University and City Unity College, she's a Ph.D. candidate in Organizational Psychology. A Harvard Business Review Advisory Council member and award recipient, Valentina is known for her work in leadership, mindset, and organizational transformation.",
};

// India
export const raajasiri_data = {
  image: raajasiri,
  from: "India",
  name: "Dr. Raajasiri Iyengar",
  banner: raajasiri_banner,
  about:
    "Dr. Raajasiri Iyengar is a public health expert and dentist with a gold medal in Pediatric Dentistry and a distinction in MPH from the University of Dundee, UK. Passionate about science communication and health research, she aims to bridge clinical and public health through impactful policies and content. Her strengths lie in simplifying complex information for public good.",
};

// Scotland
export const sagarika_data = {
  image: sagarika,
  from: "Scotland",
  name: "Sagarika Limaye",
  banner: sagarika_banner,
  about:
    "Sagarika Limaye is a dentist and public health researcher dedicated to addressing healthcare inequalities and promoting sustainable health solutions. She has led and contributed to several tobacco awareness programs in India, advocating for policy changes and community-level interventions. As part of her Master’s in Public Health at the University of Glasgow, she conducted research on the effects of ENDS on oral health, reinforcing her commitment to evidence-based advocacy.",
};


export const parveen_data = {
  id: "parveen-smith",
  image: parveen,
  from: "United Kingdom",
  name: "Parveen Smith",
  banner: parveen_banner,
  about:
    "Parveen Smith is a Multi-Global Awardee, Motivational Speaker, and Trainer advocating for mental health, well-being, and transformation. She empowers others through coaching on resilience and leadership. Overcoming severe disabilities, Parveen now speaks on global stages, trains wellness programs, and is the author of three books. Her story of surviving and thriving showcases the power of turning adversity into purpose, and she remains committed to creating a resilient and flourishing world.",
};

export const akbar_data = {
  id: "akbar-rashid",
  image: akbar,
  from: "Pakistan",
  name: "Muhammad Akbar Rashid",
  banner: akbar_banner,
  about:
    "Muhammad Akbar Rashid leads New Al-SHIFA Eye Care Center in Pakistan and brings expertise in healthcare, clinical research, and quality assurance. With published work in epidemiology and telemedicine, he champions AI-powered, patient-centric healthcare innovations. As a lecturer and quality assurance expert, his leadership contributes meaningfully to global health discourse and the enhancement of healthcare standards across developing regions.",
};

export const emmanuel_data = {
  id: "emmanuel-obeagu",
  image: emmanuel,
  from: "Zimbabwe",
  name: "Professor Emmanuel Ifeanyi Obeagu",
  banner: emmanuel_banner,
  about:
    "Professor Emmanuel Ifeanyi Obeagu is a global leader in Haematology and Public Health with over 500 published articles. Based at Africa University, Zimbabwe, he is a distinguished academic, HIV/AIDS researcher, and mentor. Known for innovations in diagnostic science and blood transfusion safety, he serves on editorial boards and policy forums globally, impacting clinical practice, medical education, and healthcare systems throughout Africa and beyond.",
};



// Create a map of all detailed orator data for easy lookup
export const orators_details_map = {
  "sagarika-limaye": sagarika_data,
  "valentina-kordi": valentina_data,
  "thelma-liverpool": thelma_data,
  "amy-gutman": amy_data,
  "esraa-elsisy": esraa_data,
  "raajasiri-iyengar": raajasiri_data,
  "srividya-narayanan": srividya_data,
  "faiza-arshad": faiza_data,
  "parveen-smith": parveen_data,
  "akbar-rashid": akbar_data,
  "emmanuel-obeagu": emmanuel_data,
};
